import React from 'react';
import { SBBox } from 'modules/Commons';
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import usePurchaseUploadErrorsHeader from './usePurchaseUploadErrorsHeader';
import { useStyles } from "../style";
import { SBTranslate } from "i18n";
import { IPurchaseCSVErrors } from 'views/PurchaseViews/PurchaseUploaderHelper/IPurchaseCSVErrors';

interface PurchaseUploaderHelperErrorProps {
    errors: IPurchaseCSVErrors[];
    handleReUpload: () => void;
}

const PurchaseUploaderHelperError: React.FC<PurchaseUploaderHelperErrorProps> = ({ errors }) => {
    const classes = useStyles();
    const { headers } = usePurchaseUploadErrorsHeader();

    return (
        <SBBox className={classes.errorsTableContainer}>
            <SBNewTable
                key={errors.length}
                startRows={errors}
                defaultColumns={headers}
                onClick={() => { }}
                title={SBTranslate("errors")}
                disableToolbar
                virtualize
                containerHeight={295}
            />
        </SBBox>
    );
};


export default PurchaseUploaderHelperError;